"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ImageLoading_1 = require("./ImageLoading");
var LoadingPlaceholder_1 = require("./LoadingPlaceholder");
var Fallback_1 = require("./Fallback");
var ImageLoad = function (props) { return (React.createElement(ImageLoading_1.default, null, function (ref, status) { return (React.createElement(React.Fragment, null, status === 'error' || !props.src
    ? React.createElement(Fallback_1.default, null)
    : React.createElement(React.Fragment, null,
        React.createElement("img", __assign({ ref: ref }, props)),
        React.createElement(LoadingPlaceholder_1.default, { style: { transition: 'opacity 0.5s', opacity: status === 'loading' ? 1 : 0 }, animate: status === 'loading' })))); })); };
exports.default = ImageLoad;
//# sourceMappingURL=Img.js.map